export default {"src":"/_next/static/media/exclamation-circle.308f93a6.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};